import React, { useState } from 'react';
import type { TreeListTopic } from '../topic/toTopicTreeList';
import TemplatesSidebarTopic from './TemplatesSidebarTopic';
import styles from './TemplatesSidebarTopics.module.scss';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const TEMPLATE_SIDEBAR_TOPICS_TOPIC_FRAGMENT = gql(`
  fragment TemplatesSidebarTopics_topic on Topic {
    id
    ...TemplatesSidebarTopic_topic
  }
`);

type TopicFragment = DocumentType<
  typeof TEMPLATE_SIDEBAR_TOPICS_TOPIC_FRAGMENT
>;

interface TemplatesSidebarTopicsProps {
  topicsTree: TreeListTopic<TopicFragment>[];
  activeTemplateId: string | null;
  onClickTemplate: (id: string) => void;
}

const TemplatesSidebarTopics = ({
  topicsTree,
  activeTemplateId,
  onClickTemplate,
}: TemplatesSidebarTopicsProps) => {
  const [collapsed, setCollapsed] = useState<{ [index: string]: boolean }>({});

  const items: JSX.Element[] = [];

  const renderTopic = (topic: TreeListTopic<TopicFragment>, path: string[]) => {
    const { childTopics, id } = topic;
    const key = [...path, id].join('.');

    const isCollapsed = collapsed[id];
    items.push(
      <TemplatesSidebarTopic
        key={key}
        level={path.length}
        topic={topic}
        isExpanded={!isCollapsed}
        activeTemplateId={activeTemplateId}
        onToggleExpanded={() =>
          setCollapsed((e) => ({ ...e, [id]: !isCollapsed }))
        }
        onClickTemplate={onClickTemplate}
      />,
    );

    if (!isCollapsed && childTopics && childTopics.length > 0) {
      const childPath = [...path, id];
      childTopics.forEach((t) => renderTopic(t, childPath));
    }
  };

  topicsTree.forEach((topic) => renderTopic(topic, []));

  return <div className={styles.sidebarTopics}>{items}</div>;
};

export default TemplatesSidebarTopics;
